import React from "react";
import Paper from "@mui/material/Paper";
import { Grid } from "@material-ui/core";
// component
import AchMethod from "pages/Settings/AchMethod";
import { getLocalStorageItem } from "utils/functions";
import RadioButtons from "components/RadioButtons/RadioButtons";
// directly import
import CreditCardList from "./CreditCardList";
import { PaymentCardTitle, PaymentCardWrapper } from "./Theme";
export const PaymentCard = ({
  formik,
  isStripe,
  addCardStripeRef,
  setSelectedCard,
  selectedCard,
  publicKey,
  getCreditCards,
  cardLoading,
  setAddNewCard,
  addNewCard,
}) => {
  const cardList = formik?.values?.listCards ?? [];

  const enableCreditCard = getLocalStorageItem("paymentMethodCreditCard", true);
  const enableAchPay = getLocalStorageItem("paymentMethodAch", true);

  const paymentTabs = [
    ...(enableCreditCard?.active
      ? [
          {
            label: "Credit card",
            value: "credit-card",
          },
        ]
      : []),
    ...(enableAchPay?.active
      ? [
          {
            label: "ACH",
            value: "ach",
            showTooltip: "ACH",
            tooltip: "ACH",
            tooltipPlacement: "top",
            disabled: enableAchPay?.paymentGateway?.provider === "Authorize",
          },
        ]
      : []),
  ];

  return (
    <>
      <Paper
        sx={{
          borderRadius: "10px",
          minHeight: 450,
          backgroundColor: (theme) =>
            theme.palette.mode === "dark" ? "#1A2027" : "#fff",
        }}
      >
        <PaymentCardWrapper>
          <PaymentCardTitle>
            <span className="title_address_details">Payment Methods</span>
          </PaymentCardTitle>

          <Grid container spacing={3}>
            {paymentTabs?.length > 1 && (
              <Grid item xs={12}>
                <RadioButtons
                  value={formik?.values?.activePayment}
                  name={"activePayment"}
                  row={true}
                  onChange={(value) => {
                    const accountInfo = formik?.values?.accountInfo;
                    formik.setFieldValue("activePayment", value);
                    if (value !== "ach") {
                      getCreditCards(accountInfo);
                    }
                  }}
                  size={"small"}
                  options={paymentTabs}
                />
              </Grid>
            )}
            {formik?.values?.activePayment === "credit-card" ? (
              <Grid item xs={12} className="d-flex align-items-center">
                <CreditCardList
                  formik={formik}
                  isStripe={isStripe}
                  setSelectedCard={setSelectedCard}
                  selectedCard={selectedCard}
                  publicKey={publicKey}
                  cardList={cardList}
                  addCardStripeRef={addCardStripeRef}
                  cardLoading={cardLoading}
                  getCreditCards={getCreditCards}
                  setAddNewCard={setAddNewCard}
                  addNewCard={addNewCard}
                />
              </Grid>
            ) : formik?.values?.activePayment === "ach" ? (
              <Grid item xs={12} className="d-flex align-items-center">
                <AchMethod bottomAdd={true} />
              </Grid>
            ) : null}
          </Grid>
        </PaymentCardWrapper>
      </Paper>
    </>
  );
};
